import { type ServiceMethod } from '@/application/interfaces/service';

export type Body = {
  cart_id: string;
};

interface Provider {
  provider: string;
  enable: boolean;
}

export type Response = {
  data: {
    providers: Provider[];
  };
};

export const createCreditCardSession: ServiceMethod<Response, Body> =
  (httpClient) => async (data, options) => {
    const { cart_id } = data;

    const { body: response } = await httpClient.post<Response, Body>(
      '/api/v3/credit-card/session',
      {
        ...options,
        body: { cart_id },
      }
    );

    return response;
  };
